import get from 'lodash.get';
import { getFooterMenuItems } from './get-footer-menu-items.esm.js';
import { getLanguageSelectorItems } from './get-language-selector-items.esm.js';
import { getLegalHubLinks } from './get-legal-hub-links.esm.js';
import { getSocialMediaLinks } from './get-social-media-links.esm.js';

/**
 * Transforms the legacy footer data into the new footer data structure
 */ const footerDataTransformer = (legacyFooterData, legacyLocalisations = {
    currentLocale: {
        locale: '',
        localeLabel: ''
    },
    translations: []
}, onChangeLocale)=>{
    return {
        items: getFooterMenuItems(legacyFooterData.categories),
        legalHubLinks: getLegalHubLinks(legacyFooterData.bottomLinks),
        socialMediaLinks: getSocialMediaLinks(legacyFooterData.socialMedia),
        languageSelector: {
            onChangeLocale,
            selectedValue: get(legacyLocalisations, 'currentLocale.localeLabel', ''),
            /**
             * TODO: This should be translated
             * TODO: Title should be renamed to label
             */ title: 'Select your language',
            items: getLanguageSelectorItems(legacyLocalisations)
        },
        label: legacyFooterData.label
    };
};

export { footerDataTransformer };
